const NORMALIZED_KEYS: Record<string, string> = {
  ArrowUp: 'up',
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  KeyW: 'up',
  KeyS: 'down',
  KeyA: 'left',
  KeyD: 'right',
  Space: 'interact',
  KeyE: 'interact',
  ShiftLeft: 'run',
  ShiftRight: 'run',
};

export class Input {
  private readonly down = new Set<string>();
  private readonly pressed = new Set<string>();
  private readonly up = new Set<string>();
  private readonly cleanup: Array<() => void> = [];

  constructor() {
    const onKeyDown = (event: KeyboardEvent): void => {
      const key = NORMALIZED_KEYS[event.code];
      if (!key) {
        return;
      }

      if (!this.down.has(key)) {
        this.pressed.add(key);
      }
      this.down.add(key);
      event.preventDefault();
    };

    const onKeyUp = (event: KeyboardEvent): void => {
      const key = NORMALIZED_KEYS[event.code];
      if (!key) {
        return;
      }

      this.down.delete(key);
      this.up.add(key);
      event.preventDefault();
    };

    window.addEventListener('keydown', onKeyDown, { passive: false });
    window.addEventListener('keyup', onKeyUp, { passive: false });
    this.cleanup.push(() => window.removeEventListener('keydown', onKeyDown));
    this.cleanup.push(() => window.removeEventListener('keyup', onKeyUp));
  }

  public isDown(key: string): boolean {
    return this.down.has(key);
  }

  public wasPressed(key: string): boolean {
    return this.pressed.has(key);
  }

  public wasReleased(key: string): boolean {
    return this.up.has(key);
  }

  public endFrame(): void {
    this.pressed.clear();
    this.up.clear();
  }

  public dispose(): void {
    for (const callback of this.cleanup) {
      callback();
    }
    this.cleanup.length = 0;
  }
}
